import {IPropertyConverter} from '@mintdata/mint-kit/api/properties/PropertyConverter';
import {ValidationMessages} from '@mintdata/mint-kit/api/properties/ValidationMessages';
import {ValidationResult} from '@mintdata/mint-kit/api/properties/ValidationResult';
import {Empty, IValue} from '@mintdata/mint-kit/api/types/Value';
import {AError} from '@mintdata/mint-kit/api/values/AError';
import {AInteger} from '@mintdata/mint-kit/api/values/AInteger';
import {AIntegerEnum} from '@mintdata/mint-kit/api/values/AIntegerEnum';
import {AStringEnum} from '@mintdata/mint-kit/api/values/AStringEnum';
import {AIntegerConverter} from '@mintdata/mint-kit/impl/properties/converters/AIntegerConverter';
import {deserialize, serialize} from '@mintdata/mint-kit/impl/util/serializr/src/serializr';

export class AIntegerEnumConverter implements IPropertyConverter<AIntegerEnum>
{
    private _valueConverter:IPropertyConverter<AInteger> = new AIntegerConverter();

    public validate(aIntegerEnumString:string, isRequired:boolean = true):ValidationResult
    {
        aIntegerEnumString = (aIntegerEnumString || '').trim();

        if( aIntegerEnumString.length === 0 )
        {
            if( isRequired )
                return ValidationResult.error(ValidationMessages.nonEmpty(AIntegerEnum));
            else
                return ValidationResult.valid();
        }

        const value:IValue = this.stringToValue(aIntegerEnumString, isRequired);

        return value && !value.isError ? ValidationResult.valid() : ValidationResult.error(value.error);
    }

    public validateValue(aIntegerEnum:AIntegerEnum, isRequired:boolean = true):ValidationResult
    {
        return this.validate(serialize(aIntegerEnum), isRequired);
    }

    public valueToString(aIntegerEnum:AIntegerEnum, isFocused:boolean = false):string
    {
        if( aIntegerEnum === Empty )
            return '';

        return aIntegerEnum && aIntegerEnum.value != null && aIntegerEnum.values
            ? this._valueConverter.valueToString(aIntegerEnum.value, isFocused)
            : '';
    }

    public stringToValue(aIntegerEnumString:string, isRequired:boolean = true):AIntegerEnum | AError
    {
        aIntegerEnumString = (aIntegerEnumString || '').trim();

        if( !isRequired && aIntegerEnumString.length === 0 )
            return Empty;

        try
        {
            const aEnum:AIntegerEnum = deserialize(AIntegerEnum, JSON.parse(aIntegerEnumString));

            return aEnum;
        }
        catch( error )
        {
        }

        return AError.fromString('Invalid AIntegerEnum value: ' + aIntegerEnumString);
    }
}

export class AStringEnumConverter implements IPropertyConverter<AStringEnum> // TODO: Finish implementation
{
    public validate(aStringEnumString:string, isRequired:boolean = true):ValidationResult
    {
        aStringEnumString = (aStringEnumString || '').trim();

        if( aStringEnumString.length === 0 )
        {
            if( isRequired )
                return ValidationResult.error(ValidationMessages.nonEmpty(AStringEnum));
            else
                return ValidationResult.valid();
        }

        const value:IValue = this.stringToValue(aStringEnumString, isRequired);

        return value && !value.isError ? ValidationResult.valid() : ValidationResult.error(value.error);
    }

    public validateValue(aStringEnum:AStringEnum, isRequired:boolean = true):ValidationResult
    {
        return this.validate(serialize(aStringEnum), isRequired);
    }

    public valueToString(aStringEnum:AStringEnum, isFocused:boolean = false):string
    {
        if( aStringEnum === Empty )
            return '';

        return aStringEnum != null ? aStringEnum.toString() : '';
    }

    public stringToValue(aStringEnumString:string, isRequired:boolean = true):AStringEnum | AError
    {
        aStringEnumString = (aStringEnumString || '').trim();

        if( !isRequired && aStringEnumString.length === 0 )
            return Empty;

        try
        {
            const aEnum:AStringEnum = deserialize(AStringEnum, JSON.parse(aStringEnumString));

            return aEnum;
        }
        catch( error )
        {
        }

        return AError.fromString('Invalid AStringEnum value: ' + aStringEnumString);
    }
}
